import React from 'react'
import {
  Anchor,
  Separator,
  Spacer,
  Text,
  Transition,
} from '@sendoutcards/quantum-design-ui'
import { useAccount, useQueries } from 'src/hooks'
import { getMarketingContent } from 'src/graphql'

const PaymentSuccess = () => {
  const account = useAccount()
  const [marketingCopy] = useQueries(getMarketingContent())
  const affiliateLink = account.isAffiliate
    ? `www.sendoutcards.com/u/${account.genealogyId}/send`
    : `www.sendoutcards.com/u/${account.sponsor?.genealogyId}/send`

  return (
    <>
      <div
        style={{ width: '100%', maxWidth: '450px' }}
        id="sent_card_confirmation"
      >
        <Transition
          title="Congratulations!"
          subtitle="You just made the world a better place"
          isLoading={false}
          loadedStatus="success"
        />
        <Spacer space="x2" />
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <Text type="caption" color="primaryBody" inset="x2">
            {marketingCopy.immediateSendEditingMessage.content}
            <br />
            {marketingCopy.futureSendEditingMessage.content}
          </Text>
        </div>
        <Spacer space="x2" />
        <Separator orientation="horizontal" dashed={true} />
        <Spacer space="x4" />
        <Text type="caption">
          Copy and share the link below to give someone else an opportunity to
          send some kindness into the world! If it’s their first card, it will
          be free!
        </Text>
        <Anchor
          size="small"
          isDecorated={true}
          href={`https://${affiliateLink}`}
        >
          {affiliateLink}
        </Anchor>
      </div>
    </>
  )
}

export default PaymentSuccess
